export const reduceAudioBufferVolume = (
  buffer: AudioBuffer,
  factor = 0.4
): AudioBuffer => {
  const context = new OfflineAudioContext(
    buffer.numberOfChannels,
    buffer.length,
    buffer.sampleRate
  )
  const reducedBuffer = context.createBuffer(
    buffer.numberOfChannels,
    buffer.length,
    buffer.sampleRate
  )

  for (let channel = 0; channel < buffer.numberOfChannels; channel++) {
    const inputData = buffer.getChannelData(channel)
    const outputData = reducedBuffer.getChannelData(channel)

    for (let i = 0; i < inputData.length; i++) {
      // @ts-ignore
      outputData[i] = inputData[i] * factor
    }
  }

  return reducedBuffer
}
